import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Api } from '../../services/api';
import { Globals } from '../../services/globals';
import { FileUploader } from 'ng2-file-upload';


@Component({
    selector: 'google-cloud-uploader',
    templateUrl: './google-cloud-uploader.component.html',
    styleUrls: ['./google-cloud-uploader.component.scss'],
    standalone: false
})
export class GoogleCloudUploaderComponent {
  @Input()
  createPoster?: boolean;

  @Input()
  posterId?: string;

  @Input()
  printFileSize?: string;

  @Input()
  posterType?: string;

  @Output()
  fileUploaded: EventEmitter<any> = new EventEmitter();

  latestFiles: any[] = [];
  latestPosters: any[] = [];

  public uploading: boolean = false;
  public uploadingComplete: boolean = false;

  public uploader?: FileUploader;
  fileOverDropZone: any = null;

  @ViewChild('fileInput')
  fileInput?: ElementRef<HTMLInputElement>;

  filesToUpload: any[] = [];

  copiedFileName?: string;


  constructor(private api: Api, private router: Router, private route: ActivatedRoute, public globals: Globals) {

  }

  getUrl() {
    return this.api.storeUrl(`/third-party/google/storage/upload-print-file?createPoster=${this.createPoster}${this.posterId ? `&posterId=${this.posterId}` : ''}${this.printFileSize ? `&printFileSize=${this.printFileSize}&posterType=${this.posterType}` : ''}`);
  }

  getFileUploaderOptions() {
    return {
      url: this.getUrl(),
      autoUpload: true,
      method: 'post',
      itemAlias: 'file',
      headers: [
        {
          name: 'Access-Code',
          value: this.globals.accessCode as string
        }
      ]
    };
  }

  async ngOnInit() {
    // this.latestFiles = await this.api.store().get<any>(`/third-party/google/storage/files/latest`);

    this.uploader = new FileUploader(this.getFileUploaderOptions());


    this.uploader.onSuccessItem = (item, response, status, headers) => {
      console.log('Success item');
      console.log(item);
      let data = JSON.parse(response);
      if (data.succeeded) {
        let file = this.filesToUpload.find(f => f.name == item.file.name);
        file.status = 'FINISHED';
        this.filesToUpload.splice(this.filesToUpload.indexOf(file), 1);

        if (data.file)
          this.latestFiles.push(data.file);
        else if (data.poster)
          this.latestPosters.push(data.poster);

        this.fileUploaded.emit(data);
      }
      else {
        this.filesToUpload.find(f => f.name == item.file.name).status = 'FAILED';
      }

      this.updateStatus();

    }

    this.uploader.onErrorItem = (item, response, status, headers) => {
      console.log('Error item');
      console.log(item);
      this.filesToUpload.find(f => f.name == item.file.name).status = 'FAILED';

      this.updateStatus();

    }
  }

  async updateStatus() {
    if (!this.filesToUpload.some(f => f.status == 'UPLOADING' || f.status == 'FAILED')) {
      this.uploading = false;
    }
  }

  public fileOver(e: any): void {
    this.uploader.setOptions(this.getFileUploaderOptions());
    this.fileOverDropZone = e;
  }



  public fileDropped(e: any): void {
    console.log('Files dropped');
    console.log(e);
    for (let i = 0; i < e.length; i++) {
      this.filesToUpload.push({
        name: e[i].name,
        status: 'UPLOADING'
      });
    }
    this.uploading = true;
  }

  openFileSelect() {
    this.fileInput?.nativeElement.click();
  }

  copySKU(fileName: string) {
    this.copiedFileName = fileName;
    navigator.clipboard.writeText(fileName.split('.')[0]);
  }



}


